// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddFileForm_wrapper__yxJRT {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 12px;
  max-width: 700px;
  background-color: #FFFFFF;
  padding: 24px;
  position: relative;
}

.AddFileForm_title__rILxh {
  font-size: 18px;
  font-weight: 600;
}

.AddFileForm_subTitle__8d5jj {
  font-size: 16px;
  color: #555F6D;
  margin-top: 4px;
  margin-bottom: 32px;
}

.AddFileForm_formContainer__1rTye {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}

.AddFileForm_inputHeader__YQJ8- {
  font-size: 16px;
  font-weight: 600;
}

.AddFileForm_close__VFFIT {
  position: absolute;
  width: 40px;
  height: 40px;
  top: 24px;
  right: 24px;
  background-color: transparent;
  border: 1px solid #CFD6DD;
  border-radius: 8px;
}

.AddFileForm_listTitle__LZ3r6 {
  margin: 16px 0 8px 0;
}

.AddFileForm_chatList__NIyK3 {
  list-style-type: none;
  padding: 0;
  margin: 0 0 32px 0;
}

.AddFileForm_chatListElement__Dk-zv {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.AddFileForm_listElementName__a3xkI {
  margin-left: 8px;
  cursor: pointer;
}

.AddFileForm_fileInput__MnHsH {
  display: none;
}

.AddFileForm_uploadButton__DV0hG {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px dashed #CFD6DD;
  margin-top: 10px;
  padding: 24px;
}

.AddFileForm_wholeSentence__T0FZg {
  font-size: 14px;
}

.AddFileForm_firstSentence__KlwDE {
  color: #1D7C4D;
}

.AddFileForm_submitContainer__FroT9 {
  display: flex;
  justify-content: center;
  margin-top: 48px;
}`, "",{"version":3,"sources":["webpack://./src/components/AddFileForm/AddFileForm.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBCTI;EDUJ,aAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,cChBQ;EDiBR,eAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;AAFJ;;AAKA;EACI,eAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,oBAAA;AAFJ;;AAKA;EACI,qBAAA;EACA,UAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,eAAA;AAFJ;;AAKA;EACI,aAAA;AAFJ;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;AAFJ;;AAKA;EACI,eAAA;AAFJ;;AAKA;EACI,cCxES;ADsEb;;AAKA;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AAFJ","sourcesContent":["@use '../../styles/colors' as colors; \n@use '../../styles/responsive' as rwd; \n\n.wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    border-radius: 12px;\n    max-width: 700px;\n    background-color: colors.$white;\n    padding: 24px;\n    position: relative;\n}\n\n.title {\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.subTitle {\n    font-size: 16px;\n    color: colors.$secondary;\n    margin-top: 4px;\n    margin-bottom: 32px;\n}\n\n.formContainer {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    width: 100%;\n}\n\n.inputHeader {\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.close {\n    position: absolute;\n    width: 40px;\n    height: 40px;\n    top: 24px;\n    right: 24px;\n    background-color: transparent;\n    border: 1px solid colors.$action;\n    border-radius: 8px;\n}\n\n.listTitle {\n    margin: 16px 0 8px 0;\n}\n\n.chatList {\n    list-style-type: none;\n    padding: 0;\n    margin: 0 0 32px 0;\n}\n\n.chatListElement {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.listElementName {\n    margin-left: 8px;\n    cursor: pointer;\n}\n\n.fileInput {\n    display: none;\n}\n\n.uploadButton {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border: 1px dashed colors.$action;\n    margin-top: 10px;\n    padding: 24px;\n}\n\n.wholeSentence {\n    font-size: 14px;\n}\n\n.firstSentence {\n    color: colors.$primaryAPP;\n}\n\n.submitContainer {\n    display: flex;\n    justify-content: center;\n    margin-top: 48px;\n}","$white: #FFFFFF;\n\n$primary: #272E35;\n\n$grey4: #DEE3E7;\n$secondary: #555F6D;\n$whitealfa: #9E9E9E;\n$emerald5: #F4EAD7;\n$emerald7: #F8F6F1;\n\n$green0: #0EB77A;\n$green4: #08200D;\n$green5: #E1F9F0;\n\n// APP\n$secondaryAPP: #D8F8E7;\n$primaryAPP: #1D7C4D;\n$primaryGreenAPP: #086E49;\n$action: #CFD6DD;\n$surface: #FCFCFD;\n$neutral: #F5F7F9;\n$raspberry: #FBD5E2;\n$greenAPP: #C6F1DA;\n$defaultAPP: #EAEDF0;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `AddFileForm_wrapper__yxJRT`,
	"title": `AddFileForm_title__rILxh`,
	"subTitle": `AddFileForm_subTitle__8d5jj`,
	"formContainer": `AddFileForm_formContainer__1rTye`,
	"inputHeader": `AddFileForm_inputHeader__YQJ8-`,
	"close": `AddFileForm_close__VFFIT`,
	"listTitle": `AddFileForm_listTitle__LZ3r6`,
	"chatList": `AddFileForm_chatList__NIyK3`,
	"chatListElement": `AddFileForm_chatListElement__Dk-zv`,
	"listElementName": `AddFileForm_listElementName__a3xkI`,
	"fileInput": `AddFileForm_fileInput__MnHsH`,
	"uploadButton": `AddFileForm_uploadButton__DV0hG`,
	"wholeSentence": `AddFileForm_wholeSentence__T0FZg`,
	"firstSentence": `AddFileForm_firstSentence__KlwDE`,
	"submitContainer": `AddFileForm_submitContainer__FroT9`
};
export default ___CSS_LOADER_EXPORT___;
